module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/152-kyrgyzstan-2223b303eebae0f11f68c821bf4d1cf4.svg";